import { EthereumErcTokenTransactionRequest } from './EthereumErcTokenTransactionRequest';

export class EthereumErc20TransactionRequest extends EthereumErcTokenTransactionRequest {
}
